<div
    class="ticket-convert-backdrop"
    (click)="onBackdropClick($event)"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ticket-convert-title"
>
    <div class="ticket-convert-panel" (click)="$event.stopPropagation()">
        <div class="modal-header" style="background-color: transparent; border-bottom: none;">
            <button type="button" class="close" (click)="onCancel()" aria-label="Fermer">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="d-flex flex-column justify-content-center text-center" style="padding: 30px 0 64px 0">
            <p id="ticket-convert-title" class="title-modal">Convertir le document</p>
            <p class="text-modal">Veuillez choisir le type de document à générer.</p>

            <div class="form-group">
                <label>
                    Convertir Ticket de caisse en
                    <span class="text-danger red-tx" aria-hidden="true">*</span>
                </label>

                <div class="checkbox-group" role="radiogroup" aria-label="Type de document">
                    <label class="container">
                        <input
                            type="radio"
                            class="form-check-input"
                            name="convertTicketType"
                            value="Facture"
                            aria-label="Facture"
                            [checked]="selectedDocumentType === 'Facture'"
                            (change)="selectDocumentType('Facture')"
                        />
                        <span class="checkmark"></span>
                        <span>Facture</span>
                    </label>
                    <label class="container">
                        <input
                            type="radio"
                            class="form-check-input"
                            name="convertTicketType"
                            value="Facture de consolidation"
                            aria-label="Facture de consolidation"
                            [checked]="selectedDocumentType === 'Facture de consolidation'"
                            (change)="selectDocumentType('Facture de consolidation')"
                        />
                        <span class="checkmark"></span>
                        <span>Facture de consolidation</span>
                    </label>
                    <label class="container">
                        <input
                            type="radio"
                            class="form-check-input"
                            name="convertTicketType"
                            value="Facture client"
                            aria-label="Facture client"
                            [checked]="selectedDocumentType === 'Facture client'"
                            (change)="selectDocumentType('Facture client')"
                        />
                        <span class="checkmark"></span>
                        <span>Facture client</span>
                    </label>
                </div>
            </div>

            <img
                *ngIf="selectedDocumentType"
                [src]="getImageSrc()"
                [alt]="(selectedDocumentType || '') + ' Preview'"
                class="mt-1 ticket-convert-preview-img"
            />

            <div class="modal-footer p-0" style="justify-content: center; gap: 16px; border-top: none;">
                <button
                    type="button"
                    class="btn btn-primary d-flex align-items-center justify-content-center"
                    style="padding: 8px 16px; font-size: 14px;"
                    (click)="onConvertClick()"
                    [disabled]="!selectedDocumentType"
                >
                    Convertir
                </button>
                <button
                    type="button"
                    class="btn d-flex align-items-center justify-content-center"
                    style="padding: 8px 16px; font-size: 14px; background-color: rgba(128, 131, 144, 0.16);"
                    (click)="onCancel()"
                >
                    Annuler
                </button>
            </div>
        </div>
    </div>
</div>
